module.exports = __webpack_public_path__ + "img/movie3.a7660557.png";